import { rawVestaContract } from '.';
import { proxyNetworkProvider, resultsParser } from '..';

export const getRawVestaFarmDistributionAmount = async () => {
  const query = rawVestaContract.methods
    .getRawVestaFarmDistributionAmount([0])
    .check()
    .buildQuery();
  const response = await proxyNetworkProvider.queryContract(query);
  const { firstValue, returnCode } = resultsParser.parseQueryResponse(
    response,
    rawVestaContract.getEndpoint('getRawVestaFarmDistributionAmount')
  );
  if (!returnCode.isSuccess()) {
    return [];
  } else {
    return (
      firstValue?.valueOf().map((v: any) => ({
        address: v[0].bech32(),
        amount: v[1].toString()
      })) ?? []
    );
  }
};

export interface RawVestaComputedDistribution {
  address: string;
  amount: string;
}
